import { gql } from '@apollo/client';

const getMediaPricingInventoryQuery = (includeInventory) => {
  return gql`
      query MediaPriceInventory($itemIds: [String!]!,  $storeId: String!) {
          mediaPriceInventory(itemIds: $itemIds, storeId: $storeId) {
              productDetailsList {
                  itemId
                  itemType
                  imageLocation
                  pricing {
                    value
                    original
                    message
                    mapAboveOriginalPrice
                    __typename
                  }
                  storeInventory @include(if: ${includeInventory}) {
                    adjustedQuantity
                    totalQuantity
                    enableItem
                    __typename
                  }
                 onlineInventory @include(if: ${includeInventory}) {
                    adjustedQuantity
                    totalQuantity
                    enableItem
                    __typename
                 }
                 __typename
              }
              __typename
          }
      }
  `;
};

export default getMediaPricingInventoryQuery;
